var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page--list d-flex justify-center align-center"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.salvar.apply(null, arguments);
      }
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticClass: "mb-4"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('h1', {
    staticClass: "primary--text page-title"
  }, [_vm._v(" Dados do Profissional ")])])], 1)], 1), _c('v-divider'), _c('section', [_c('v-subheader', {
    staticClass: "ml-0 mt-3",
    attrs: {
      "inset": ""
    }
  }, [_c('strong', [_vm._v("Dados Pessoais")])]), _c('v-row', {
    staticClass: "px-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "nome",
      "label": "Nome*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "100",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.form.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form, "nome", $$v);
      },
      expression: "form.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "cpf",
      "label": "CPF",
      "dense": "",
      "outlined": "",
      "disabled": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.cpf,
      callback: function ($$v) {
        _vm.$set(_vm.form, "cpf", $$v);
      },
      expression: "form.cpf"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "px-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "email",
      "label": "E-mail*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "100",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '(##) #####-####',
      expression: "'(##) #####-####'"
    }],
    attrs: {
      "id": "telefone",
      "label": "Telefone para contato*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "15",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.form.telefone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "telefone", $$v);
      },
      expression: "form.telefone"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "px-3 mb-3"
  }, [_c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "my-2 mr-2"
  }, [_vm._v("Possui nome social?")]), _c('v-switch', {
    staticClass: "my-2 pa-0",
    attrs: {
      "hide-details": "",
      "label": _vm.temNomeSocial ? 'Sim' : 'Não'
    },
    model: {
      value: _vm.temNomeSocial,
      callback: function ($$v) {
        _vm.temNomeSocial = $$v;
      },
      expression: "temNomeSocial"
    }
  })], 1), _vm.temNomeSocial ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome Social*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "100",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.form.nomeSocial,
      callback: function ($$v) {
        _vm.$set(_vm.form, "nomeSocial", $$v);
      },
      expression: "form.nomeSocial"
    }
  })], 1) : _vm._e()], 1)], 1), _c('v-divider'), _c('section', [_c('v-subheader', {
    staticClass: "ml-0 mt-7",
    attrs: {
      "inset": ""
    }
  }, [_c('strong', [_vm._v("Formação Profissional")])]), _c('v-row', {
    staticClass: "px-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "grauEscolaridade",
      "label": "Grau de Escolaridade*",
      "items": _vm.$opcoesGrauEscolaridade,
      "item-text": 'descricao',
      "item-value": 'value',
      "outlined": "",
      "hide-details": "auto",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.form.grauEscolaridade,
      callback: function ($$v) {
        _vm.$set(_vm.form, "grauEscolaridade", $$v);
      },
      expression: "form.grauEscolaridade"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "funcaoPrograma",
      "label": "Função no Programa*",
      "items": _vm.lists.listaFuncaoPrograma,
      "item-text": 'nome',
      "item-value": 'id',
      "outlined": "",
      "hide-details": "auto",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.form.funcaoPrograma,
      callback: function ($$v) {
        _vm.$set(_vm.form, "funcaoPrograma", $$v);
      },
      expression: "form.funcaoPrograma"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "px-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "municipioFormacao",
      "label": "Município*",
      "items": _vm.lists.listaMunicipioFormacao,
      "item-text": 'nome',
      "item-value": 'id',
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "return-object": "",
      "rules": [function (v) {
        return v && v.id ? true : 'Campo obrigatório';
      }]
    },
    on: {
      "change": _vm.filtrarLotacoesPorMunicipio
    },
    model: {
      value: _vm.form.municipioFormacao,
      callback: function ($$v) {
        _vm.$set(_vm.form, "municipioFormacao", $$v);
      },
      expression: "form.municipioFormacao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "localLotacao",
      "label": "Local de Lotação*",
      "items": _vm.lists.listaLocalLotacao,
      "item-text": 'nome',
      "item-value": 'id',
      "outlined": "",
      "hide-details": "auto",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, _vm.lotacoesValidas]
    },
    model: {
      value: _vm.form.localLotacao,
      callback: function ($$v) {
        _vm.$set(_vm.form, "localLotacao", $$v);
      },
      expression: "form.localLotacao"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "px-3"
  }, [_c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "my-2 mr-2"
  }, [_vm._v("Possui outro local de lotação?")]), _c('v-switch', {
    staticClass: "my-2",
    attrs: {
      "hide-details": "",
      "label": _vm.temLotacaoSecundaria ? 'Sim' : 'Não'
    },
    model: {
      value: _vm.temLotacaoSecundaria,
      callback: function ($$v) {
        _vm.temLotacaoSecundaria = $$v;
      },
      expression: "temLotacaoSecundaria"
    }
  })], 1)], 1), _vm.temLotacaoSecundaria ? _c('v-row', {
    staticClass: "px-3 mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    key: _vm.lotacaoSecundariaKey,
    attrs: {
      "id": "municipioFormacaoSecundario",
      "label": "Município*",
      "items": _vm.lists.listaMunicipioFormacao,
      "item-text": 'nome',
      "item-value": 'id',
      "hide-details": "auto",
      "outlined": "",
      "dense": "",
      "return-object": "",
      "rules": [function (v) {
        return v && v.id ? true : 'Campo obrigatório';
      }]
    },
    on: {
      "change": _vm.filtrarLotacoesSecundariasPorMunicipio
    },
    model: {
      value: _vm.form.municipioFormacaoSecundario,
      callback: function ($$v) {
        _vm.$set(_vm.form, "municipioFormacaoSecundario", $$v);
      },
      expression: "form.municipioFormacaoSecundario"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "localLotacaoSecundario",
      "label": "Local de Lotação*",
      "items": _vm.lists.listaLocalLotacaoSecundaria,
      "item-text": 'nome',
      "item-value": 'id',
      "disabled": !_vm.form.municipioFormacaoSecundario,
      "hide-details": "auto",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, _vm.lotacoesValidas]
    },
    model: {
      value: _vm.form.lotacaoSecundaria,
      callback: function ($$v) {
        _vm.$set(_vm.form, "lotacaoSecundaria", $$v);
      },
      expression: "form.lotacaoSecundaria"
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-divider'), _c('section', [_c('v-subheader', {
    staticClass: "ml-0 mt-7",
    attrs: {
      "inset": ""
    }
  }, [_c('strong', [_vm._v("Endereço Residencial")])]), _c('v-row', {
    staticClass: "px-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '##.###-###',
      expression: "'##.###-###'"
    }],
    attrs: {
      "id": "cep",
      "label": "CEP*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "10",
      "counter": "10",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    on: {
      "blur": _vm.buscarEnderecoPorCep
    },
    model: {
      value: _vm.form.cep,
      callback: function ($$v) {
        _vm.$set(_vm.form, "cep", $$v);
      },
      expression: "form.cep"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "logradouro",
      "label": "Logradouro*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "100",
      "counter": "100",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.form.logradouro,
      callback: function ($$v) {
        _vm.$set(_vm.form, "logradouro", $$v);
      },
      expression: "form.logradouro"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "px-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "bairro",
      "label": "Bairro*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "100",
      "counter": "100",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.form.bairro,
      callback: function ($$v) {
        _vm.$set(_vm.form, "bairro", $$v);
      },
      expression: "form.bairro"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "uf",
      "label": "UF*",
      "items": _vm.$opcoesUFS,
      "item-text": 'value',
      "item-value": 'value',
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    on: {
      "change": _vm.filtrarMunicipioPorUF
    },
    model: {
      value: _vm.form.uf,
      callback: function ($$v) {
        _vm.$set(_vm.form, "uf", $$v);
      },
      expression: "form.uf"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "municipioEndereco",
      "label": "Município*",
      "items": _vm.lists.listaMunicipioEndereco,
      "item-text": 'nome',
      "item-value": 'nome',
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.form.municipio,
      callback: function ($$v) {
        _vm.$set(_vm.form, "municipio", $$v);
      },
      expression: "form.municipio"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "px-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "numero",
      "label": "Número*",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "10",
      "counter": "10",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.form.numero,
      callback: function ($$v) {
        _vm.$set(_vm.form, "numero", $$v);
      },
      expression: "form.numero"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "complemento",
      "label": "Complemento",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "maxlength": "100",
      "counter": "100"
    },
    model: {
      value: _vm.form.complemento,
      callback: function ($$v) {
        _vm.$set(_vm.form, "complemento", $$v);
      },
      expression: "form.complemento"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "alert-message d-flex align-center mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Os campos marcados com asterisco(*) são obrigatórios")])], 1), _c('v-row', {
    staticClass: "py-4 pr-2 mt-7",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.salvar
    }
  }, [_vm._v("Salvar")]), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "dark": "",
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/Login');
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }